<template lang="pug">
  b-modal#modal-scrollable(
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-bg-variant="options.headerBgVariant",
    :header-text-variant="options.headerTextVariant",
    :body-bg-variant="options.bodyBgVariant",
    :body-text-variant="options.bodyTextVariant",
    :footer-bg-variant="options.footerBgVariant",
    :footer-text-variant="options.footerTextVariant",
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
      img(src="@/assets/admin_main_log.svg" style="height: 20px")
    b-container(fluid)
      slot
    template(slot="modal-footer")
      b-button.float-right(
        variant="primary"
        @click="$emit('close')"
      ) {{$t('submit')}}
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {
        return {
          size: "lg",
          title: "",
          context: "",
          headerBgVariant: "light",
          headerTextVariant: "dark",
          bodyBgVariant: "light",
          bodyTextVariant: "dark",
          footerBgVariant: "light",
          footerTextVariant: "dark",
          align: "left",
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.offline-block {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 5;
  > div {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin-top: -50px;
  }
}

.image-wrap {
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.help-section {
  margin: 30px 0;
  > p {
    margin-left: 12px;
  }
}

::v-deep .b-table {
  margin: 0;

  tr,
  td,
  th {
    padding: 0.75rem 1.25rem;
    position: relative;
    font-weight: 400;
  }

  th:nth-child(1),
  th:nth-child(2),
  th:nth-child(3),
  th:nth-child(4),
  th:nth-child(5) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    width: 20% !important;
  }

  td:nth-child(1),
  td:nth-child(2),
  td:nth-child(3),
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6f6f6f;
  }

  td button {
    /* icon 요소에 대한 스타일 */
    position: absolute;
    top: 50%; /* td의 50% 높이에 위치하도록 설정 */
    transform: translateY(-50%); /* 위에서 설정한 top 값만큼 위로 이동하여 가운데 정렬 */
    /* icon 요소에 대한 스타일을 추가로 설정 */
  }
}

.btn-secondary {
  color: #6f6f6f !important;
  background-color: #ffffff;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.lmm-table-list-modal-header {
  background-color: #f8f9fa !important;
}

.bg-light {
  background-color: transparent !important;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

.close-btn {
  background-color: transparent;
  border: transparent;
}
</style>
